import * as React from 'react';
import { SimpleBarChart } from '../../datenauswertung/helper/simpleBarChart';

export interface EnergiekostenPreisentwicklungProps {
    data: any;
    values: any;
}

export class EnergiekostenPreisentwicklung extends React.Component<EnergiekostenPreisentwicklungProps, {}> {

    private chartColors = [
        '#bccae3', '#6f91be', '#686868', '#728a49', '#ea9956', '#eee',
        '#4ea72e', '#a02b93', '#0f9ed5', '#156082', '#e97132', '#196b24',
        '#4f81bd', '#f79646', '#87bd51', '#5163bd', '#9951bd', '#bd5175'
    ];

    getChartData(): any {
        const { values } = this.props;
        const dataRows: any[] = [];
        const YKeysMap: any = {};
        Object.keys(values || {}).forEach((key: string) => {
            const row: any = {
                energietraeger: values[key].name2 || values[key].name,
                yKeyColors: this.chartColors
            };
            Object.keys(values[key].jahre || {}).forEach((jahr: string) => {
                row[jahr] = values[key].jahre[jahr].preis;
                YKeysMap[jahr] = true;
            });
            dataRows.push(row);
        });
        const YKeys = Object.keys(YKeysMap).sort();
        const legends: any[] = YKeys.map((jahr: string, idx: number) => {
            return { color: this.chartColors[idx % this.chartColors.length], legend: jahr };
        });
        let XAxisAngle: number, XAxisHeight: number = 60;
        if (dataRows.length > 7) {
            XAxisAngle = -35;
            XAxisHeight = 90;
        }
        const barSize: number = dataRows.length > 0 ? 150 / dataRows.length - 5 : undefined;
        return { dataRows, YKeys, legends, XAxisAngle, XAxisHeight, barSize };
    }

    render(): JSX.Element {
        const { dataRows, YKeys, legends, XAxisAngle, XAxisHeight, barSize } = this.getChartData();
        return <>
            <div style={{ fontSize: 12, fontWeight: 600, textAlign: 'center', padding: '15px 0', backgroundColor: '#efefef' }}>
                Prognostizierte Preisentwicklung
            </div>
            <div style={{ fontSize: 12, padding: 10, marginLeft: -10 }}>
                {dataRows.length > 0 ?
                    <SimpleBarChart
                        id='Chart_EnergiekostenPreisentwicklung'
                        key={`Chart_EnergiekostenPreisentwicklung_${dataRows.length}`}
                        fontSize={'12px'}
                        data={dataRows}
                        containerSize={{ width: '100%', height: 230 + XAxisHeight - 10 }}
                        XKey={'energietraeger'}
                        YKeys={YKeys}
                        XAxisAngle={XAxisAngle}
                        XAxisHeight={XAxisHeight}
                        // YAxisLabel={{ value: '€', position: 'insideLeft', /* angle: -90, position: 'insideLeft', offset: -10 */ }}
                        YAxisUnit={' €'}
                        YAxisLine={false}
                        YAxisTickLine={false}
                        barSize={barSize}
                        useTicksRender={true}
                        tooltipType='standard'
                        customLegends={legends}
                        legendProps={{
                            position: 'right',
                            style: { width: 60 }
                        }}
                    />
                    :
                    <p>Bitte wählen Sie mindestens einen Energieträger aus!</p>
                }
            </div>
        </>;
    }
}
